import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_64qjr4iy: FaireBrandEntity = {
  token: "b_64qjr4iy",
  type: "brand",
  name: "Lenny & Eva",
  avatarUrl:
    "https://cdn.faire.com/fastly/a5daf872dccdf19c1925217b84cfebdbc6a044447855c27d580f4f637699d418.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/98f67a666cd736134da8cc02b65978e52456c19ce8c9428f9c43e359a4125fc0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/a5daf872dccdf19c1925217b84cfebdbc6a044447855c27d580f4f637699d418.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/98f67a666cd736134da8cc02b65978e52456c19ce8c9428f9c43e359a4125fc0.png",
  location: "Baxter, TN, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 241,
  isTopShop: true,
  isInsider: true,
  description:
    "At Lenny & Eva, we believe in the power of words and the beauty of meaningful, timeless jewelry. Founded with a vision to inspire and empower, each piece we create is designed to tell a story—your story. Whether it's a reminder of faith, strength, or a cherished memory, our jewelry is made to accompany you through all of life's moments, big and small.\n\nOur collection combines elegant designs with heartfelt messages, offering a blend of simplicity, versatility, and charm. From our signature bangles to our delicate earrings, each item is crafted with care, using high-quality materials that reflect both style and substance.\n\nLenny & Eva is more than just a jewelry brand; it’s a celebration of personal growth, faith, and the connections that define us. We hope our pieces serve as a daily source of inspiration, encouraging you to embrace your journey with grace, courage, and love.\n\nWelcome to Lenny & Eva—where every piece has a purpose, and every story matters.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:57.084Z",
    importedBy: "entity-db-cli",
  },
};
